import React, { createContext, useContext, useState } from "react";

const DataManagerContext = createContext();

export const useDataManager = () => {
    return useContext(DataManagerContext);
}

export const DataManagerProvider = ({ children }) => {
    const [priceIDToBuyMonth, setPriceIDToBuyMonth] = useState("")
    const [priceIDToBuyAnnual, setPriceIDToBuyAnnual] = useState("")
    const [customerID, setCustomerID] = useState("")
    const [productName, setProductName] = useState("")
    const [isFoundersClub, setIsFoundersClub] = useState(null) // boolean

    return(
        <DataManagerContext.Provider value={{priceIDToBuyMonth, setPriceIDToBuyMonth, priceIDToBuyAnnual, setPriceIDToBuyAnnual, customerID, setCustomerID, productName, setProductName, isFoundersClub, setIsFoundersClub}}>
            {children}
        </DataManagerContext.Provider>
    )
}